<template>
  <v-card tile>
    <v-card-title class="grey lighten-2">
      <v-icon class="mr-4">mdi-alert</v-icon>
      Ett fel inträffade!
    </v-card-title>

    <v-card-text class="mt-8">
      <p v-for="(error, $i) in errors" :key="$i">
        <code>{{ error }}</code>
      </p>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer />
      <v-btn rounded @click="closeModal">
        Stäng
      </v-btn>
      <v-btn rounded color="error" @click="confirmError">
        {{ isUnauth ? 'Logga ut' : 'Ladda om' }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
  name: 'ErrrorModal',

  computed: {
    errors: get('app/errors'),

    isUnauth() {
      return this.errors.some(x => x.includes('unauthenticated'))
    }
  },

  methods: {
    confirmError() {
      if (this.isUnauth) {
        return this.$sso.logout()
      }
      this.$store.set('app/showErrorModal', false)
      window.location = window.location.origin
    },

    closeModal() {
      this.$store.set('app/showErrorModal', false)
    }
  }
}
</script>
